import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ingsv-adm-icons',
  templateUrl: './icons.component.html',
  styleUrls: ['./icons.component.scss']
})
export class IconsComponent {
  @Input() icon = '';
  @Input() color = '';
  @Input() size = '';
  @Input() direction = '';
}
